// frontend/src/sections/Home/Hero/Hero.jsx

import React from "react";
import Stats from "../Stats/Stats";
import HeroBg from "./HeroBg";
import HeroContact from "./HeroContact";

export default function Hero() {
  return (
    <section className="relative px-3 sm:px-5">
      {/* پنل اصلی قهرمان: کانتینر بزرگ و گرد مثل قالب نمونه */}
      <div className="relative isolate mx-auto max-w-[1380px] overflow-hidden rounded-[2.25rem] bg-ink shadow-[0_50px_100px_-40px_rgba(7,21,15,0.75)] sm:rounded-[3rem]">
        <HeroBg />

        <div className="pointer-events-none absolute -right-40 -top-40 z-[1] h-[520px] w-[520px] rounded-full bg-emerald-500/20 blur-[110px]" />
        <div className="pointer-events-none absolute -left-40 bottom-[-220px] z-[1] h-[520px] w-[520px] rounded-full bg-floodlight/[0.12] blur-[110px]" />

        <div className="relative z-10 pb-24 sm:pb-28">
          <HeroContact />
        </div>
      </div>

      {/* آمار: کارت‌های شیشه‌ای شناور روی لبه‌ی پایین پنل */}
      <Stats />
    </section>
  );
}
